// extracted by mini-css-extract-plugin
export var ContentWrapper = "n_bp";
export var Image = "n_bn";
export var ToggleableEmbed = "n_bm";